const downloadAsFile = (content: Blob, fileName: string) => {
  const a = document.createElement('a')
  const url = URL.createObjectURL(content)
  a.href = url
  a.download = fileName
  a.click()
  URL.revokeObjectURL(url)
}

export { downloadAsFile }
